import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstance2wgh00a9s97su as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static c1s() {
        return createThis(this);
      }
      j1r(descriptor) {
        return this;
      }
      k1r(descriptor) {
      }
      d1s(descriptor, index) {
        return true;
      }
      e1s(value) {
        throw SerializationException().n1o('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      f1s() {
        throw SerializationException().n1o("'null' is not supported by default");
      }
      g1s(value) {
        return this.e1s(value);
      }
      h1s(value) {
        return this.e1s(value);
      }
      i1s(value) {
        return this.e1s(value);
      }
      j1s(value) {
        return this.e1s(value);
      }
      k1s(value) {
        return this.e1s(value);
      }
      l1s(value) {
        return this.e1s(value);
      }
      m1s(value) {
        return this.e1s(value);
      }
      n1s(value) {
        return this.e1s(new (Char())(value));
      }
      o1s(value) {
        return this.e1s(value);
      }
      p1s(enumDescriptor, index) {
        return this.e1s(index);
      }
      q1s(descriptor) {
        return this;
      }
      r1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.g1s(value);
        }
      }
      s1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.h1s(value);
        }
      }
      t1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.i1s(value);
        }
      }
      u1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.j1s(value);
        }
      }
      v1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.k1s(value);
        }
      }
      w1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.l1s(value);
        }
      }
      x1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.m1s(value);
        }
      }
      y1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.n1s(value);
        }
      }
      z1s(descriptor, index, value) {
        if (this.d1s(descriptor, index)) {
          this.o1s(value);
        }
      }
      a1t(descriptor, index) {
        return this.d1s(descriptor, index) ? this.q1s(descriptor.v1p(index)) : NoOpEncoder_getInstance();
      }
      b1t(descriptor, index, serializer, value) {
        if (this.d1s(descriptor, index)) {
          this.c1t(serializer, value);
        }
      }
      d1t(descriptor, index, serializer, value) {
        if (this.d1s(descriptor, index)) {
          this.e1t(serializer, value);
        }
      }
    }
    protoOf($).f1t = encodeNotNullMark;
    protoOf($).g1t = beginCollection;
    protoOf($).c1t = encodeSerializableValue;
    protoOf($).e1t = encodeNullableSerializableValue;
    protoOf($).h1t = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
